'use strict'

import React, { Fragment, useEffect, useState } from 'react'
import Select from 'react-select'

import { getCurrencies, getIpInfo } from '../selectors'
import refreshSvg from '../assets/images/refresh.svg'

import {
  currencySymbol,
  customizeSelectTheme,
  getCurrencyName,
  getSelectOptions,
  getSelectValue
} from '../shared'

const Form = ({
  duration,
  period,
  setup,
  attendees,
  salary,
  fromCurrency,
  toCurrency,
  onChangeSelect
}) => {
  const currencies = getCurrencies()
  const ipInfo = getIpInfo()
  const [currencySet, setCurrencySet] = useState(false)

  const fromCurrencyValue = {
    label: `${currencySymbol(fromCurrency)} ${getCurrencyName(
      currencies,
      fromCurrency
    )}`,
    value: fromCurrency
  }

  const toCurrencyValue = {
    label: `${currencySymbol(toCurrency)} ${getCurrencyName(
      currencies,
      toCurrency
    )}`,
    value: toCurrency
  }

  const currencyOptions = Object.keys(currencies).map(key => {
    return {
      label: `${currencySymbol(key)} ${currencies[key]}`,
      value: key
    }
  })

  useEffect(() => {
    if (ipInfo.hasOwnProperty('ip')) {
      if (!currencySet) {
        Object.keys(currencies).some(key => {
          const countryCode = ipInfo.country_code
          const countryName = ipInfo.country_name
          if (
            key.includes(countryCode) ||
            currencies[key].includes(countryName)
          ) {
            const salary = key === 'ZAR' ? 25000 : 5000
            const toCurrency = key === 'ZAR' ? 'GBP' : 'USD'
            setCurrencySet(true)
            onChangeSelect('salary', { value: salary })
            onChangeSelect('fromCurrency', { value: key })
            onChangeSelect('toCurrency', { value: toCurrency })
          }
        })
      }
    }
  }, [ipInfo.ip])

  const onSwapCurrency = e => {
    e.preventDefault()
    onChangeSelect('fromCurrency', { value: toCurrency })
    onChangeSelect('toCurrency', { value: fromCurrency })
  }

  const renderSelect = (name, value, options) => {
    return (
      <Select
        name={name}
        id={name}
        value={value}
        options={options}
        className={'d-block w-100'}
        aria-label={name}
        aria-labelledby={name}
        onChange={option => onChangeSelect(name, option)}
        theme={theme => customizeSelectTheme(theme)}
      />
    )
  }

  return (
    <Fragment>
      <div className='flex flex-row flex-wrap	items-stretch my-2 text-xl'>
        <div className='w-full md:w-1/3 p-2'>
          <p className='mb-2 text-lg semi-bold'>What is the duration?</p>
          {renderSelect(
            'duration',
            getSelectValue('duration', duration),
            getSelectOptions('duration')
          )}
        </div>
        <div className='w-full md:w-1/3 p-2'>
          <p className='mb-2 text-lg semi-bold'>How often?</p>
          {renderSelect(
            'period',
            getSelectValue('period', period),
            getSelectOptions('period')
          )}
        </div>
        <div className='w-full md:w-1/3 p-2'>
          <p className='mb-2 text-lg semi-bold'>Time setting up?</p>
          {renderSelect(
            'setup',
            getSelectValue('setup', setup),
            getSelectOptions('setup')
          )}
        </div>
      </div>
      <div className='flex flex-row flex-wrap items-stretch my-2 text-lg'>
        <div className='w-full md:w-1/3 p-2'>
          <p className='mb-2 text-lg semi-bold'>Number of attendees?</p>
          {renderSelect(
            'attendees',
            getSelectValue('attendees', attendees),
            getSelectOptions('attendees')
          )}
        </div>
        <div className='w-full md:w-2/3 p-2'>
          <p className='mb-2 text-lg semi-bold'>
            Monthly average salary{' '}
            <span className='bold'>
              ({getCurrencyName(currencies, fromCurrency)})
            </span>
          </p>
          {renderSelect(
            'salary',
            getSelectValue('salary', salary),
            getSelectOptions('salary', fromCurrency)
          )}
        </div>
      </div>
      <div className='flex flex-col md:flex-row flex-wrap items-stretch my-2 text-lg'>
        <div className='flex-1 p-2'>
          <p className='mb-2 text-lg semi-bold'>From currency</p>
          {renderSelect('fromCurrency', fromCurrencyValue, currencyOptions)}
        </div>
        <div className='flex-shrink mt-0 md:mt-6 p-2 self-center'>
          <img
            src={refreshSvg}
            alt='Swap curencies'
            className='h-12 mx-auto mt-0 mb:mt-6 p-2 hover:bg-gray-400 rounded cursor-pointer'
            onClick={onSwapCurrency}
          />
        </div>
        <div className='flex-1 p-2'>
          <p className='mb-2 text-lg semi-bold'>To currency</p>
          {renderSelect('toCurrency', toCurrencyValue, currencyOptions)}
        </div>
      </div>
    </Fragment>
  )
}

export default Form
